module.exports = __webpack_public_path__ + "statics/img/5.2496eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/solution/5.png
// module id = lvKZ
// module chunks = 1